import React, { useLayoutEffect, useRef, useState } from 'react';

interface MarqueeTextProps {
  text: string;
  className?: string;
}

/**
 * Truncates when it fits; scrolls horizontally when the text overflows.
 */
const MarqueeText: React.FC<MarqueeTextProps> = ({ text, className = '' }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLSpanElement>(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const measure = measureRef.current;
    if (!container || !measure) return;

    const check = () => {
      setShouldScroll(measure.offsetWidth > container.clientWidth + 1);
    };

    check();
    const observer = new ResizeObserver(check);
    observer.observe(container);
    return () => observer.disconnect();
  }, [text]);

  return (
    <div ref={containerRef} className={`relative min-w-0 overflow-hidden ${className}`}>
      <span
        ref={measureRef}
        className="pointer-events-none absolute left-0 top-0 whitespace-nowrap opacity-0"
        aria-hidden
      >
        {text}
      </span>
      {shouldScroll ? (
        <span className="marquee-track inline-flex whitespace-nowrap">
          <span>{text}</span>
          <span className="px-6" aria-hidden>{text}</span>
        </span>
      ) : (
        <span className="block truncate">{text}</span>
      )}
    </div>
  );
};

export default MarqueeText;
